import React, {useEffect} from "react";
import nProgress from "nprogress";
import 'nprogress/nprogress.css'

function PageLoading() {
    useEffect(() => {
        nProgress.start()
        return () => {
            nProgress.done()
        }
    }, [])

    return null
}

export default PageLoading